module.exports = __webpack_public_path__ + "media/images/city_img/title_2-88430c4f4c723bfb9a65c2da1455070b.png";